"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _HBButton = require("./HBButton.styles");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _HBButton2 = require("./HBButton.utils");
var buttonSizeToLoaderSize = {
  xs: 'xs',
  sm: 'xs',
  md: 'small',
  lg: 'small',
  xl: 'small'
};
var HBButton = function HBButton(_ref) {
  var id = _ref.id,
    testIdName = _ref.testIdName,
    testId = _ref.testId,
    testIdType = _ref.testIdType,
    _ref$buttonTheme = _ref.buttonTheme,
    buttonTheme = _ref$buttonTheme === void 0 ? 'primary' : _ref$buttonTheme,
    customTheme = _ref.customTheme,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? 'system' : _ref$scope,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    icon = _ref.icon,
    _ref$iconPosition = _ref.iconPosition,
    iconPosition = _ref$iconPosition === void 0 ? 'start' : _ref$iconPosition,
    _ref$shouldUseIconDef = _ref.shouldUseIconDefaultFill,
    shouldUseIconDefaultFill = _ref$shouldUseIconDef === void 0 ? false : _ref$shouldUseIconDef,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    children = _ref.children,
    onClick = _ref.onClick,
    className = _ref.className,
    _ref$loaderColor = _ref.loaderColor,
    loaderColor = _ref$loaderColor === void 0 ? _colors["default"].neutral900 : _ref$loaderColor,
    textTransform = _ref.textTransform,
    tabIndex = _ref.tabIndex,
    _ref$margin = _ref.margin,
    margin = _ref$margin === void 0 ? '0' : _ref$margin;
  var baseProps = {
    id: id,
    disabled: disabled || loading,
    tabIndex: tabIndex,
    fullWidth: fullWidth,
    size: size,
    scope: scope,
    type: type,
    className: className,
    textTransform: textTransform
  };
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName || id,
    suffix: 'button',
    componentName: 'HBButton',
    testIdType: testIdType
  });
  var ButtonComponent = customTheme ? _HBButton.CustomButton : _HBButton.Button;
  var wrappedChildren = (0, _HBButton2.recursivelyWrapStringChildrenWithSpans)(children);
  var loaderSize = buttonSizeToLoaderSize[size];
  return /*#__PURE__*/_react["default"].createElement(ButtonComponent, (0, _extends2["default"])({}, baseProps, {
    onClick: onClick,
    "data-testid": finalTestId,
    "data-testidtype": testIdType,
    theme: buttonTheme,
    customTheme: customTheme,
    $margin: margin,
    $shouldUseIconDefaultFill: shouldUseIconDefaultFill
  }), loading && /*#__PURE__*/_react["default"].createElement(_HBButton.Loader, {
    size: loaderSize,
    color: loaderColor
  }), icon && /*#__PURE__*/_react["default"].createElement(_HBButton.IconWrapper, {
    iconPosition: iconPosition,
    size: size
  }, icon), wrappedChildren);
};
var _default = exports["default"] = HBButton;
//# sourceMappingURL=HBButton.js.map